import { useEffect, useState } from 'react';

/*
    Show key terms after 1000ms on mobile and 1750ms on desktop, so the page settles first. On mobile, show
    the first 6 until the student asks for more.
*/

const MOBILE_DELAY_MS = 1000;
const DESKTOP_DELAY_MS = 1750;
const MOBILE_PREVIEW_COUNT = 6;

export function useKeyTermsReveal(keyTermCount: number, isMobile: boolean) {
    const [isReady, setIsReady] = useState(false);
    const [showAll, setShowAll] = useState(!isMobile);

    useEffect(() => {
        const timeout = setTimeout(() => setIsReady(true), isMobile ? MOBILE_DELAY_MS : DESKTOP_DELAY_MS);
        return () => clearTimeout(timeout);
    }, [isMobile]);

    // A resize across the mobile width resets "Show All".
    useEffect(() => {
        setShowAll(!isMobile);
    }, [isMobile]);

    return {
        isReady,
        hasHiddenKeyTerms: isReady && !showAll && keyTermCount > MOBILE_PREVIEW_COUNT,
        showAllKeyTerms: () => setShowAll(true),
    };
}
